<script lang="ts">
    import { onMount } from "svelte";

    let className: string = "";
    export { className as class};
    export let score: number = 1.0;
    export let max: number = 2.0;
    export let min: number = 0.0;
    export let size: number = 160;

    let style: string = "";

    $: {
        const normalized = Math.min(Math.max(min, score), max);
        const ratingScore = Math.round(((normalized - min) / (max - min)) * 100);
        
        let ratingColor = "#000";
        if (score >= 0.6) {
            ratingColor = "#ff0000";
        }
        if (score > 0.77) {
            ratingColor = "#cccccc";
        } 
        if (score > 1) {
            ratingColor = "#ffff00";
        } 
        if (score > 1.5) {
            ratingColor = "#ffff00";
        }
        
        style = `background: conic-gradient(${ratingColor} ${ratingScore}%, transparent 0 100%); 
            color: ${ratingColor}; font-size: ${size/3}px; height: ${size}px; width: ${size}px;`;
    }
</script>

<div class="rating {className}" style={style}>
    <span>
    <slot />
    </span>
</div>